import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Tooltip } from '@mui/material';
import type { SnackbarOrigin } from 'notistack';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledBundleActionButton } from '../styled';

const SNACKBAR_AUTO_HIDE_DURATION = 4000;

interface CopyTextButtonProps {
  text: string;
}

const CopyTextButton = ({ text }: CopyTextButtonProps) => {
  const { t } = useTranslation();

  const { enqueueSnackbar } = useSnackbar();

  const showSnackbar = useCallback(() => {
    const anchorOrigin: SnackbarOrigin = {
      vertical: 'top',
      horizontal: 'center',
    };
    enqueueSnackbar(t('general:action:copied'), {
      variant: 'success',
      anchorOrigin,
      autoHideDuration: SNACKBAR_AUTO_HIDE_DURATION,
    });
  }, [t, enqueueSnackbar]);

  const handleClick = useCallback(() => {
    navigator.clipboard.writeText(text);
    showSnackbar();
  }, [text, showSnackbar]);

  return (
    <Tooltip title={t('general:action:copy')}>
      <StyledBundleActionButton
        onClick={handleClick}
        sx={{
          svg: {
            height: '70%',
            width: 'auto',
          },
        }}
      >
        <ContentCopyIcon />
      </StyledBundleActionButton>
    </Tooltip>
  );
};

export default CopyTextButton;
